import operations from '~/helpers/device-operations';
import {
    batteryTemperatureLevel,
    installationIlim,
    installationVoltage,
    nbCharge,
    stateCharge,
    stateOfHealth,
} from '~/helpers/fields-description';
import { Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Camera } from './camera.model';

export class NDB extends Camera {

    minimumRebootFirmware = 77;
    minimumUnlockFirmware = 0;

    installation_voltage?: number;
    installation_ilim?: number;
    battery_charge_cnt?: number;
    battery_temperature_level?: number;
    battery_soh?: number;

    get fieldInstallationVoltage(): FieldObject | undefined {
        return installationVoltage(this.installation_voltage);
    }
    get fieldInstallationIlim(): FieldObject | undefined {
        return installationIlim(this.installation_ilim);
    }
    get fieldStateCharge(): FieldObject | undefined {
        return stateCharge(this.battery_percent);
    }
    get fieldStateOfHealth(): FieldObject | undefined {
        return stateOfHealth(this.battery_soh);
    }
    get fieldNbCharge(): FieldObject | undefined {
        return nbCharge(this.battery_charge_cnt);
    }
    get fieldBatteryTemperatureLevel(): FieldObject | undefined {
        return batteryTemperatureLevel(this.battery_temperature_level);
    }

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.electricalReset({ callback: this.electricalReset }),
            operations.associateUser({ disabled: this.associateUserDisabled })
        ]);
    }

}
